import { type InputHTMLAttributes, forwardRef, useId } from 'react';
import clsx from 'clsx';

interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: string;
  error?: string;
}

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  ({ label, error, className, id, ...rest }, ref) => {
    const reactId = useId();
    const inputId = id || reactId;

    return (
      <div className="flex items-start gap-2">
        <input
          ref={ref}
          type="checkbox"
          id={inputId}
          className={clsx(
            'h-4 w-4 rounded border-gray-300 text-brand-600 focus:ring-brand-500',
            error && 'border-red-500',
            className
          )}
          {...rest}
        />
        {label && (
          <label
            htmlFor={inputId}
            className={clsx(
              'text-sm',
              error ? 'text-red-600' : 'text-gray-700'
            )}
          >
            {label}
          </label>
        )}
        {error && (
          <p className="text-xs text-red-600">{error}</p>
        )}
      </div>
    );
  }
);

Checkbox.displayName = 'Checkbox';
